import styled from "@emotion/styled";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import theme from "../../styles/theme";

export const SmallPostCardBase = styled.div`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  height: 100%;
  position: relative;

  :hover .image,
  :focus .image {
    transform: scale(1.075);
  }
`;

export const ImageContainer = styled.div`
  border-radius: 5px;
  flex: 1;
  overflow: hidden;
  position: relative;
`;

export const Image = styled(GatsbyImage)`
  object-fit: cover;
  transition: all 0.25s;
  height: 100%;
  width: 100%;
  aspect-ratio: 4 / 3;
`;

export const FallbackImage = styled.img`
  object-fit: cover;
  transition: all 0.25s;
  height: 100%;
  width: 100%;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SubjectLink = styled(Link)`
  text-decoration: none;
  ::after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: " ";
  }
`;

export const Title = styled.p`
  flex-basis: 100%; /* Take up full row */
  margin: 0 0 8px 0;
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${theme.largerThan.md} {
    margin: 16px 0 4px 0;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ResourceButton = styled(Link)`
  color: ${theme.colors.blues[100]};
  display: inline-block;
  font-size: 20px;
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
`;

export const Headline = styled.h2`
  text-align: center;
  margin: 0 auto 28px;

  ${theme.largerThan.sm} {
    margin-bottom: 40px;
  }
`;

export const CapabilitiesList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 24px;

  ${theme.largerThan.sm} {
    grid-row-gap: 48px;
    margin-bottom: 48px;
  }

  ${theme.largerThan.lg} {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  ${theme.largerThan.xl} {
    grid-template-columns: repeat(auto-fit, minmax(224px, 1fr));
  }

  & > a {
    height: 258px;

    ${theme.largerThan.md} {
      height: 315px;
      min-width: 160px;
    }
  }
`;
